<!-- Header -->
<div class="navigation-wrapper">

  <div class="primary-navigation-wrapper department-menu">
    <header class="second-nav" id="top" role="banner" *ngFor="let dept of deptData">
      <div class="container">
        <div class="row">
          <nav class="col-md-8">
            <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
              <span class="navbar-toggler-icon"></span>
            </button> -->
            <div class="" id="collapsibleNavbar" *ngFor="let cdata of countData">
              <ul class="">
                <li class="active">
                  <a (click)="navigatePage('dept_home',dept)">Home</a>
                </li>
                <li *ngIf="this.cdata.courses != 0">
                  <a (click)="navigatePage('degrees',dept.id)">Programmes</a>
                </li>
<!--                <li *ngIf="this.cdata.faq != 0">-->
<!--                  <a (click)="navigatePage('faq',dept.id)">FAQ</a>-->
<!--                </li>-->
                <li *ngIf="this.cdata.staff != 0">
                  <a (click)="navigatePage('deptstaff',dept.id)">Members</a>
                </li>
<!--                <li>-->
<!--                  <a href="#">About</a>-->
<!--                </li>-->
              </ul>
            </div>
          </nav>

          <div class="social col-md-4">
            <div class="icons">

            <span *ngFor="let link of linksData">
              <span *ngIf="link.link_type.type=='FACEBOOK' || link.link_type.type=='YOUTUBE' || link.link_type.type=='LINKED_IN'">
                <a href="{{link.link_url}}" target="_blank">
                  <i *ngIf="link.link_type.type=='FACEBOOK'" class="fa fa-facebook"></i>&nbsp;
                  <i *ngIf="link.link_type.type=='YOUTUBE'" class="fa fa-youtube-play"></i>&nbsp;
                  <i *ngIf="link.link_type.type=='LINKED_IN'" class="fa fa-linkedin"></i>
                </a>
              </span>
            </span>
             | {{dept.email}} | {{dept.phone}}
            </div><!-- /.icons -->
          </div>
        </div>
      </div><!-- /.container -->
    </header><!-- /.navbar -->
  </div><!-- /.primary-navigation -->
</div>
<!-- end Header -->
